import { ToggleButton } from "@clipboard-health/ui-components";

import { FiltersToggleButtonGroup } from "./BottomSheet/ToggleButtonGroup";
import { type FiltersFormValues } from "./BottomSheet/types";
import { FILTER_ALL_VALUE, useFilterSelectedOptions } from "./BottomSheet/useFilterSelectedOptions";

interface IncludedStatesFilterButtonGroupProps {
  value?: FiltersFormValues["includedStates"];
  onChange: (value: FiltersFormValues["includedStates"]) => void;
  availableStates: string[];
}

export function IncludedStatesFilterButtonGroup(props: IncludedStatesFilterButtonGroupProps) {
  const { value, onChange, availableStates } = props;

  const { selectedOptions, onChangeSelection } = useFilterSelectedOptions(
    value ?? [],
    onChange,
    availableStates
  );

  // Safety check to avoid showing an empty filter, likely never to happen.
  if (availableStates.length === 0) {
    return null;
  }

  const isSelected = (state: string) =>
    selectedOptions.includes(state) || selectedOptions.includes(FILTER_ALL_VALUE);

  return (
    <FiltersToggleButtonGroup
      value={selectedOptions}
      aria-label="States Filter Toggle Buttons"
      onChange={(newValue) => {
        onChangeSelection(newValue ?? []);
      }}
    >
      <ToggleButton value={FILTER_ALL_VALUE}>All</ToggleButton>
      {availableStates.map((state) => (
        <ToggleButton
          key={state}
          value={state}
          selected={isSelected(state)}
          iconType={isSelected(state) ? "checkmark" : undefined}
        >
          {state}
        </ToggleButton>
      ))}
    </FiltersToggleButtonGroup>
  );
}
